import React from 'react';
import {useStyles} from './TakisArticleHero.styles';
import TakisDivider from './TakisDivider';
import TakisPicture from './TakisPicture';
import PropTypes from 'prop-types';

function TakisArticleHero({imageSrc, imageTabletSrc, imageMobileSrc, imageAlt}) {
  const classes = useStyles();
  const images = [
    {
      url: imageMobileSrc,
      size: "mobile"
    },
    {
      url: imageTabletSrc,
      size: "tablet"
    },
    {
      url: imageSrc,
      size: "desktop"
    }
  ];

  TakisArticleHero.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    imageTabletSrc: PropTypes.string.isRequired,
    imageMobileSrc: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired,
  };

  return (
    <div className={classes.hero}>
      <div className={classes.heroWrapper}>
        <TakisPicture
          pictureClass={classes.heroImage}
          images={images}
          isLazy={false}
          altText={imageAlt}
        />
      </div>
      <TakisDivider
        variation={2}
        modifier={classes.divider}
        backgroundColor="transparent"
        marginModifier={classes.dividerMargin}
      />
    </div>
  );
}

export default TakisArticleHero;
